import { LOGOUT_PAGE } from "Network/ApiUrl";
import { constants } from "../Constants";
import { TFunction } from "react-i18next";
import toast from "react-hot-toast";

export const isRequired = (value: string) => {
  if (value === "" || value === undefined || value === null) {
    return true;
  }
  return false;
};

export function validateEmail(email: string) {
  const emailRegx = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,16})+$/);
  return emailRegx.test(email) !== false;
}
export function validatePhoneNumber(phonenumber: string) {
  const phonenumberRegx = new RegExp(
    /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/
  );
  return phonenumberRegx.test(phonenumber) !== false;
}
export function isValidUrl(url: string) {
  const urlRegex = new RegExp(
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
  );

  const result = url.match(urlRegex);
  return result !== null;
}

export function isPassword(value: string) {
  const str = value;
  if (
    str.match(/[a-z]/g) &&
    str.match(/[A-Z]/g) &&
    str.match(/[0-9]/g) &&
    str.match(/[^a-zA-Z\d]/g) &&
    str.length >= 6 &&
    str.length <= 16
  ) {
    return true;
  }
  return false;
}
export function isCheckUppercase(value: string) {
  const str = value;
  if (str.match(/[A-Z]/g)) {
    return true;
  }
  return false;
}
export function isCheckLowercase(value: string) {
  const str = value;
  if (str.match(/[a-z]/g)) {
    return true;
  }
  return false;
}
export function isCheckNumber(value: string) {
  const str = value;
  if (str.match(/[A-Z]/g)) {
    return true;
  }
  return false;
}
export function isCheckSpecialChar(value: string) {
  const str = value;
  if (str.match(/[^a-zA-Z\d]/g)) {
    return true;
  }
  return false;
}
export function isCheckMinLength(value: string) {
  const str = value;
  if (str.length >= 6) {
    return true;
  }
  return false;
}
export function isCheckMaxLength(value: string) {
  const str = value;
  if (str.length <= 16) {
    return true;
  }
  return false;
}
export const handleError = (
  data: any,
  t: TFunction<"translation", undefined>
) => {
  Object.keys(data).map((item) => {
    toast.error(t(`Translation.${data[item]}`));
  });
};
export const logout = () => {
  localStorage.clear();
  location.href = LOGOUT_PAGE;
};
export const convertCamelCase = (item: string) => {
  return item.substring(0, 1).toUpperCase() + item.substring(1);
};
export const validateStartAndEndDate = (startDate: string, endDate: string) => {
  return Date.parse(startDate) <= Date.parse(endDate);
};

export const addbodyclass = () => {
  document.body.classList.add("modal-open-scroll");
};
export function removebodyclass() {
  document.body.className = "";
}
export function formatTime24to12Hour(timeString: any) {
  const [hourString, minute, sec] = timeString.split(":");

  const hour = +hourString % 24;
  return (
    (hour % 12 || 12) +
    ":" +
    minute +
    ":" +
    sec +
    " " +
    (hour < 12 ? "AM" : "PM")
  );
}

export const backGroundScroll = (isModalOpen: boolean) => {
  if (isModalOpen) {
    document.body.className = "modal-open-scroll";
  } else {
    document.body.classList.remove("modal-open-scroll");
  }
};

function padTo2Digits(num: number) {
  return num.toString().padStart(2, "0");
}

export const miliSecondsToTime = (miliSec: number, timeFormat: string) => {
  let seconds = Math.floor(miliSec / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);

  seconds = seconds % 60;
  minutes = minutes % 60;

  hours = hours % 24;

  return timeFormat === constants.HOUR_12
    ? formatTime24to12Hour(
        padTo2Digits(hours) +
          ":" +
          padTo2Digits(minutes) +
          ":" +
          padTo2Digits(seconds)
      )
    : padTo2Digits(hours) +
        ":" +
        padTo2Digits(minutes) +
        ":" +
        padTo2Digits(seconds);
};

export const formatDate = (date: Date) => {
  var year = date.toLocaleString("default", { year: "numeric" });
  var month = date.toLocaleString("default", { month: "2-digit" });
  var day = date.toLocaleString("default", { day: "2-digit" });
  return year + "-" + month + "-" + day;
};

export const getReadableAddress = (address: string) => {
  return address && String(address.replaceAll(",", "").split(" ").splice(1));
};

export const anchorMe = (value: string) => {
  const linkRegex =
    /((http(s)?(\:\/\/))?(www\.)?(\w)*(\.[a-zA-Z]{2,4}\/?))(?!([\/a-z<\/a>])|(\'|\"))/g;
  var newValue = value.replace(linkRegex, (link: string) => {
    return `<a target="_blank" href=${link}>${link.split("https://")[1]}</a>`;
  });
  return newValue;
};

export const getLinkFromHTML = (html: string) => {
  let div = document.createElement("div");
  div.innerHTML = html;
  div.querySelectorAll("a").forEach((elem: HTMLAnchorElement) => {
    div.removeChild(elem);
    div.innerHTML += elem.href;
  });
  return div.innerHTML;
};

export const openLinkToNewTab = (htmlContent: string) => {
  const rxp = /(?<=\{)[^\{\}]+(?=\})/g;
  const contentLink: any = rxp.exec(htmlContent)?.[0].split(",");
  if (contentLink) {
    var anchor = `<a target="_blank" href=${contentLink[1]}>${contentLink[0]}</a>`;
    const anchoredText = htmlContent.replace(/\{(.+?)\}/g, anchor);
    return anchoredText;
  } else {
    return htmlContent;
  }
};

// This function reverse the above function
export const textFromAnchor = (value: string) => {
  let div = document.createElement("div");
  div.innerHTML = value;
  div.querySelectorAll("a").forEach((element: HTMLAnchorElement) => {
    const link = element.href;
    const text = element.innerText;
    div.removeChild(element);
    div.innerText = value.replace(/<a[^>]*>([^<]+)<\/a>/g, `{${text},${link}}`);
  });
  return div.innerHTML;
};

export const sort = (array: any[], sort_by: string = "order") => {
  for (let index = 0; index < array.length; index++) {
    for (let loopIndex = 0; loopIndex < array.length - index - 1; loopIndex++) {
      if (array[loopIndex][sort_by] > array[loopIndex + 1][sort_by]) {
        const temp = array[loopIndex];
        array[loopIndex] = array[loopIndex + 1];
        array[loopIndex + 1] = temp;
      }
    }
  }
  return array;
};

export const getRandomId = () => String((Math.random() + Date.now()) * 10000);

// used for DragAndDrop
export const reorder = (list: any, startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
